<template>
    <div>
        <template>
            <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--bottom">
                <div class="kgr-postfix__fixed">
                    <kgr-month-picker
                        :month="month"
                        :year="year"
                        @change="onSelectedMonthChanged($event)"
                    />
                </div>
                <div class="kgr-postfix__fixed">
                    <a
                        :href="linkBooking"
                        class="kgr-button kgr-button--accent"
                    >{{ $t('Zur Buchung') }}</a>
                </div>
            </div>

            <div>
                <h2 class="kgr-headline kgr-headline--h3 kgr-headline--text">
                    {{ $t('Abzurechnende Zeiten') }}
                </h2>
                <h3 class="kgr-headline kgr-headline--h4 kgr-headline--text">
                    {{ $t('Zusätzlich genutzte Betreuungseinheiten') }}
                </h3>

                <div :class="{ 'content-loading': loadingPlusTimes > 0 }">
                    <div class="content-spinner">
                        <kgr-loading />
                    </div>

                    <table
                        v-if="plusTimes.length > 0"
                        class="kgr-table kgr-table--striped kgr-table--block table-groups kgr-row kgr-row--bigMargin"
                    >
                        <thead>
                            <tr class="kgr-table__row">
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Datum') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Zeitraum') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('time_account.duration') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline dynamic">
                                    {{ $t('Betreuungsgebühr') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline kgr-table__cell--actions"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="plusTime in plusTimes"
                                :id="`plusTime-${plusTime.id}`"
                                :key="plusTime.id"
                            >
                                <td class="kgr-table__cell">
                                    {{ plusTime.formattedDay }}, {{ plusTime.weekday }}
                                </td>
                                <td class="kgr-table__cell">
                                    <div class="kgr-postfix kgr-postfix--center">
                                        <div class="kgr-postfix__fluid">
                                            <kgr-time-range-picker
                                                :start="plusTime.timeRange.start.toString()"
                                                :end="plusTime.timeRange.end.toString()"
                                                @change="updatePlusTime(plusTime, $event)"
                                            />
                                        </div>
                                        <div class="kgr-postfix__fixed">
                                            <img
                                                v-if="plusTime.hint !== ''"
                                                src="@img/warning.png"
                                                :title="plusTime.hint"
                                                style="vertical-align: middle; margin-left: 0.5rem"
                                            />
                                        </div>
                                    </div>
                                </td>
                                <td class="kgr-table__cell">
                                    {{ duration(plusTime) }}
                                </td>
                                <td class="kgr-table__cell">
                                    <kgr-care-cost-hourly-picker
                                        :selected="plusTime.careCostHourly"
                                        @change="changeCareCost(plusTime, $event)"
                                    />
                                </td>
                                <td class="kgr-table__cell kgr-table__cell--actions">
                                    <a
                                        class="kgr-button kgr-button--accent kgr-button--small"
                                        @click="deletePlusTime(plusTime)"
                                    >{{ $t('entfernen') }}</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div
                        v-else
                        class="kgr-alert kgr-alert--info"
                    >
                        {{ $t('Keine Daten vorhanden.') }}
                    </div>
                </div>

                <h3 class="kgr-headline kgr-headline--h4 kgr-headline--text">
                    {{ $t('Nicht genutzte Betreuungseinheiten') }}
                </h3>
                <div :class="{ 'content-loading': loadingMinusTimes > 0 }">
                    <div class="content-spinner">
                        <kgr-loading />
                    </div>

                    <table
                        v-if="minusTimes.length > 0"
                        class="kgr-table kgr-table--striped kgr-table--block table-groups kgr-row kgr-row--bigMargin"
                    >
                        <thead>
                            <tr class="kgr-table__row">
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Datum') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Zeitraum') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('time_account.duration') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline dynamic"></th>
                                <th class="kgr-table__cell kgr-table__cell--headline kgr-table__cell--actions"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="minusTime in minusTimes"
                                :id="`minusTime-${minusTime.id}`"
                                :key="minusTime.id"
                            >
                                <td class="kgr-table__cell">
                                    {{ minusTime.formattedDay }}, {{ minusTime.weekday }}
                                </td>
                                <td class="kgr-table__cell">
                                    <div class="kgr-postfix kgr-postfix--center">
                                        <div class="kgr-postfix__fluid">
                                            <kgr-time-range-picker
                                                :start="minusTime.timeRange.start.toString()"
                                                :end="minusTime.timeRange.end.toString()"
                                                @change="updateMinusTime(minusTime, $event)"
                                            />
                                        </div>
                                        <div class="kgr-postfix__fixed">
                                            <img
                                                v-if="minusTime.hint !== ''"
                                                src="@img/warning.png"
                                                :title="minusTime.hint"
                                                style="vertical-align: middle; margin-left: 0.5rem"
                                            />
                                        </div>
                                    </div>
                                </td>
                                <td class="kgr-table__cell">
                                    {{ duration(minusTime) }}
                                </td>
                                <td class="kgr-table__cell">
&nbsp;
                                </td>
                                <td class="kgr-table__cell kgr-table__cell--actions">
                                    <a
                                        class="kgr-button kgr-button--accent kgr-button--small"
                                        @click="deleteMinusTime(minusTime)"
                                    >{{ $t('entfernen') }}</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div
                        v-else
                        class="kgr-alert kgr-alert--info"
                    >
                        {{ $t('Keine Daten vorhanden.') }}
                    </div>
                </div>

                <h2
                    class="kgr-headline kgr-headline--h3"
                    style="margin-top: 2rem"
                >
                    {{ $t('Vorschlagsliste') }}
                </h2>
                <div style="position: relative">
                    <h3 class="kgr-headline kgr-headline--h4 kgr-headline--text">
                        {{ $t('Zusätzlich genutzte Betreuungseinheiten') }}
                    </h3><p
                        v-if="!showPlusTimeSuggestions"
                        class="status"
                    >
                        {{ $t('(ausgeblendet)') }}
                    </p>
                    <div
                        class="toogleListView"
                        @click="toggleVisibilityPlusTimeSuggestions()"
                    >
                        <a
                            v-if="showPlusTimeSuggestions"
                            class="kgr-link"
                        >{{ $t('Liste ausblenden') }}</a>
                        <a
                            v-else
                            class="kgr-link"
                        >{{ $t('Liste einblenden') }}</a>
                    </div>
                </div>
                <transition name="fade">
                    <div v-if="showPlusTimeSuggestions">
                        <div :class="{ 'content-loading': loadingPlusTimeSuggestions > 0 }">
                            <div class="content-spinner">
                                <kgr-loading />
                            </div>

                            <div v-if="plusTimeSuggestions.length > 0">
                                <div class="kgr-row">
                                    <a
                                        v-if="selectedPlusTimes.length < plusTimeSuggestions.length"
                                        class="bulk_select"
                                        @click="selectedPlusTimes = plusTimeSuggestions"
                                    >{{ $t('alle auswählen') }}</a>
                                    <a
                                        v-else
                                        class="textlinkDisabled"
                                    >{{ $t('alle auswählen') }}</a>
                                    |
                                    <a
                                        v-if="selectedPlusTimes.length > 0"
                                        class="bulk_select"
                                        @click="selectedPlusTimes = []"
                                    >{{ $t('alle abwählen') }}</a>
                                    <a
                                        v-else
                                        class="textlinkDisabled"
                                    >{{ $t('alle abwählen') }}</a>
                                </div>

                                <table class="kgr-table kgr-table--striped kgr-table--block table-groups kgr-row kgr-row--bigMargin">
                                    <thead>
                                        <tr class="kgr-table__row">
                                            <th class="kgr-table__cell kgr-table__cell--headline select"></th>
                                            <th class="kgr-table__cell kgr-table__cell--headline">
                                                {{ $t('Datum') }}
                                            </th>
                                            <th class="kgr-table__cell kgr-table__cell--headline">
                                                {{ $t('Zeitraum') }}
                                            </th>
                                            <th class="kgr-table__cell kgr-table__cell--headline">
                                                {{ $t('time_account.duration') }}
                                            </th>
                                            <th class="kgr-table__cell kgr-table__cell--headline dynamic">
                                                {{ $t('Kommentar') }}
                                            </th>
                                            <th class="kgr-table__cell kgr-table__cell--headline"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="plusTime in plusTimeSuggestions"
                                            class="kgr-table__row"
                                        >
                                            <td class="kgr-table__cell">
                                                <label class="kgr-checkbox">
                                                    <input
                                                        v-model="selectedPlusTimes"
                                                        type="checkbox"
                                                        class="kgr-checkbox__control"
                                                        :value="plusTime"
                                                    />
                                                    <span class="kgr-checkbox__label"></span>
                                                </label>
                                            </td>
                                            <td class="kgr-table__cell">
                                                {{ plusTime.formattedDay }}, {{ plusTime.weekday }}
                                            </td>
                                            <td class="kgr-table__cell">
                                                {{ plusTime.timeRange }}
                                                <img
                                                    v-if="plusTime.hint !== ''"
                                                    src="@img/warning.png"
                                                    :title="plusTime.hint"
                                                    style="vertical-align: middle; margin-left: 0.5rem"
                                                />
                                            </td>
                                            <td class="kgr-table__cell">
                                                {{ plusTime.duration }}
                                            </td>
                                            <td class="kgr-table__cell">
                                                <ul v-if="plusTime.comments.length > 0">
                                                    <li v-for="comment in plusTime.comments">
                                                        {{ comment }}
                                                    </li>
                                                </ul>
                                            </td>
                                            <td class="kgr-table__cell kgr-table__cell--actions">
                                                <button
                                                    class="kgr-button kgr-button--accent"
                                                    @click="applyPlusTime(plusTime)"
                                                >
                                                    {{ $t('übernehmen') }}
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr class="kgr-table__row">
                                            <td
                                                class="kgr-table__cell"
                                                colspan="6"
                                            >
                                                <a
                                                    v-if="selectedPlusTimes.length > 0"
                                                    class="kgr-button kgr-button--accent"
                                                    @click="bulkSendPlusTimes()"
                                                >{{ $t('Auswahl übernehmen') }}</a>
                                                <a
                                                    v-else
                                                    class="kgr-button is-disabled"
                                                >{{ $t('Auswahl übernehmen') }}</a>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            <div
                                v-else
                                class="kgr-alert kgr-alert--info"
                            >
                                {{ $t('Keine Daten vorhanden.') }}
                            </div>
                        </div>
                    </div>
                </transition>

                <div style="position: relative">
                    <h3 class="kgr-headline kgr-headline--h4 kgr-headline--text">
                        {{ $t('Nicht genutzte Betreuungseinheiten') }}
                    </h3><p
                        v-if="!showMinusTimeSuggestions"
                        class="status"
                    >
                        {{ $t('(ausgeblendet)') }}
                    </p>
                    <div
                        class="toogleListView"
                        @click="toggleVisibilityMinusTimeSuggestions()"
                    >
                        <a
                            v-if="showMinusTimeSuggestions"
                            class="kgr-link"
                        >{{ $t('Liste ausblenden') }}</a>
                        <a
                            v-else
                            class="kgr-link"
                        >{{ $t('Liste einblenden') }}</a>
                    </div>
                </div>

                <transition name="fade">
                    <div
                        v-if="showMinusTimeSuggestions"
                        class="kgr-row kgr-row--extraBigMargin"
                    >
                        <div :class="{ 'content-loading': loadingMinusTimeSuggestions > 0 }">
                            <div class="content-spinner">
                                <kgr-loading />
                            </div>
                            <div v-if="minusTimeSuggestions.length > 0">
                                <div class="kgr-row">
                                    <a
                                        v-if="selectedMinusTimes.length < minusTimeSuggestions.length"
                                        class="kgr-link bulk_select"
                                        @click="selectedMinusTimes = minusTimeSuggestions"
                                    >{{ $t('alle auswählen') }}</a>
                                    <a
                                        v-else
                                        class="textlinkDisabled"
                                    >{{ $t('alle auswählen') }}</a>
                                    |
                                    <a
                                        v-if="selectedMinusTimes.length > 0"
                                        class="kgr-link bulk_select"
                                        @click="selectedMinusTimes = []"
                                    >{{ $t('alle abwählen') }}</a>
                                    <a
                                        v-else
                                        class="textlinkDisabled"
                                    >{{ $t('alle abwählen') }}</a>
                                </div>
                                <table class="kgr-table kgr-table--striped kgr-table--block table-groups kgr-row kgr-row--bigMargin">
                                    <thead>
                                        <tr class="kgr-table__row">
                                            <th class="kgr-table__cell kgr-table__cell--headline select"></th>
                                            <th class="kgr-table__cell kgr-table__cell--headline">
                                                {{ $t('Datum') }}
                                            </th>
                                            <th class="kgr-table__cell kgr-table__cell--headline">
                                                {{ $t('Zeitraum') }}
                                            </th>
                                            <th class="kgr-table__cell kgr-table__cell--headline">
                                                {{ $t('time_account.duration') }}
                                            </th>
                                            <th class="kgr-table__cell kgr-table__cell--headline dynamic">
                                                {{ $t('Kommentar') }}
                                            </th>
                                            <th class="kgr-table__cell kgr-table__cell--headline"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="minusTime in minusTimeSuggestions"
                                            class="kgr-table__row"
                                        >
                                            <td class="kgr-table__cell">
                                                <label class="kgr-checkbox">
                                                    <input
                                                        v-model="selectedMinusTimes"
                                                        type="checkbox"
                                                        class="kgr-checkbox__control"
                                                        :value="minusTime"
                                                    />
                                                    <span class="kgr-checkbox__label"></span>
                                                </label>
                                            </td>
                                            <td class="kgr-table__cell">
                                                {{ minusTime.formattedDay }}, {{ minusTime.weekday }}
                                            </td>
                                            <td class="kgr-table__cell">
                                                {{ minusTime.timeRange }}
                                                <img
                                                    v-if="minusTime.hint !== ''"
                                                    src="@img/warning.png"
                                                    :title="minusTime.hint"
                                                    style="vertical-align: middle; margin-left: 0.5rem"
                                                />
                                            </td>
                                            <td class="kgr-table__cell">
                                                {{ minusTime.duration }}
                                            </td>
                                            <td class="kgr-table__cell">
                                                <ul v-if="minusTime.comments.length > 0">
                                                    <li v-for="comment in minusTime.comments">
                                                        {{ comment }}
                                                    </li>
                                                </ul>
                                            </td>
                                            <td class="kgr-table__cell kgr-table__cell--actions">
                                                <button
                                                    class="kgr-button kgr-button--accent"
                                                    @click="applyMinusTime(minusTime)"
                                                >
                                                    {{ $t('übernehmen') }}
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>

                                    <tfoot>
                                        <tr class="kgr-table__row">
                                            <td
                                                class="kgr-table__cell"
                                                colspan="6"
                                            >
                                                <a
                                                    v-if="selectedMinusTimes.length > 0"
                                                    class="kgr-button kgr-button--accent"
                                                    @click="bulkSendMinusTimes()"
                                                >{{ $t('Auswahl übernehmen')
                                                }}</a>
                                                <a
                                                    v-else
                                                    class="kgr-button is-disabled"
                                                >{{ $t('Auswahl übernehmen') }}</a>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            <div
                                v-else
                                class="kgr-alert kgr-alert--info"
                            >
                                {{ $t('Keine Daten vorhanden.') }}
                            </div>
                        </div>
                    </div>
                </transition>

                <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--center kgr-row">
                    <div class="kgr-postfix__fluid">
                        <h2 class="kgr-headline kgr-headline--h3">
                            {{ $t('Stundennachweise') }}
                        </h2>
                    </div>
                    <div class="kgr-postfix__fixed">
                        <button
                            class="kgr-button kgr-button--accent"
                            @click="createProof()"
                        >
                            {{ $t('Stundennachweis erstellen') }}
                        </button>
                    </div>
                </div>

                <div class="kgr-row">
                    <a
                        v-if="selectedProofOfTimes.length < proofOfTimes.length"
                        class="kgr-link bulk_select"
                        @click="selectedProofOfTimes = proofOfTimes"
                    >{{ $t('alle auswählen') }}</a>
                    <a
                        v-else
                        class="textlinkDisabled"
                    >{{ $t('alle auswählen') }}</a>
                    |
                    <a
                        v-if="selectedProofOfTimes.length > 0"
                        class="kgr-link bulk_select"
                        @click="selectedProofOfTimes = []"
                    >{{ $t('alle abwählen') }}</a>
                    <a
                        v-else
                        class="textlinkDisabled"
                    >{{ $t('alle abwählen') }}</a>
                </div>

                <div :class="{ 'content-loading': loadingProof > 0 }">
                    <div class="content-spinner">
                        <kgr-loading />
                    </div>
                    <table
                        v-if="proofOfTimes.length > 0"
                        class="kgr-table kgr-table--striped kgr-table--block table-groups kgr-row kgr-row--bigMargin"
                    >
                        <thead>
                            <tr class="kgr-table__row">
                                <th class="kgr-table__cell kgr-table__cell--headline select"></th>
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Erstellt') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline dynamic">
                                    {{ $t('proof_of_child_times.headline') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(proof, index) in proofOfTimes"
                                class="kgr-table__row"
                            >
                                <td class="kgr-table__cell">
                                    <label class="kgr-checkbox">
                                        <input
                                            :id="`proof_${index}`"
                                            v-model="selectedProofOfTimes"
                                            type="checkbox"
                                            class="kgr-checkbox__control"
                                            :value="proof"
                                        />
                                        <span class="kgr-checkbox__label"></span>
                                    </label>
                                </td>
                                <td class="kgr-table__cell">
                                    {{ proof.created }}
                                </td>
                                <td class="kgr-table__cell">
                                    {{ proof.name }}
                                </td>
                                <td class="kgr-table__cell kgr-table__cell--actions">
                                    <a
                                        class="kgr-table__action"
                                        :href="proof.link"
                                    >
                                        <kgr-icon-download :title="$t('file.browser.download')" />
                                    </a>
                                    <a
                                        class="kgr-table__action"
                                        target="_blank"
                                        :href="proof.linkPreview"
                                    >
                                        <kgr-icon-preview :title="$t('file.browser.view')" />
                                    </a>
                                    <a
                                        class="kgr-table__action"
                                        @click="deleteProofOfTime(proof)"
                                    >
                                        <kgr-icon-delete :title="$t('entfernen')" />
                                    </a>
                                </td>
                            <!-- <td class="kgr-table__cell"><span v-if="proof.is_up_to_date">{{ $t('time_account.up_to_date') }}</span></td> -->
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr class="kgr-table__row">
                                <td
                                    class="kgr-table__cell"
                                    colspan="4"
                                >
                                    <a
                                        v-if="selectedProofOfTimes.length > 0"
                                        class="kgr-button kgr-button--accent"
                                        @click="deleteProofOfTimeBulk()"
                                    >
                                        {{ $t('Auswahl entfernen') }}</a>
                                    <a
                                        v-else
                                        class="kgr-button is-disabled"
                                    >{{ $t('Auswahl entfernen') }}</a>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                    <div
                        v-else
                        class="kgr-alert kgr-alert--info"
                    >
                        {{ $t('Keine Daten vorhanden.') }}
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import CareCostHourlyPicker from './common/form/picker/CareCostHourlyPicker.vue';
import ChildTimeManagementRepository from '../js/repository/ChildTimeManagementRepository';
import IconDelete from './common/icon/IconDelete.vue';
import IconDownload from './common/icon/IconDownload.vue';
import IconPreview from './common/icon/IconPreview.vue';
import Loading from './common/Loading.vue';
import MonthPicker from './common/form/picker/MonthPicker.vue';
import TimeRangePicker from './common/form/picker/TimeRangePicker.vue';

export default {
    components: {
        'kgr-loading': Loading,
        'kgr-month-picker': MonthPicker,
        'kgr-icon-delete': IconDelete,
        'kgr-icon-download': IconDownload,
        'kgr-icon-preview': IconPreview,
        'kgr-time-range-picker': TimeRangePicker,
        'kgr-care-cost-hourly-picker': CareCostHourlyPicker,
    },
    props: {
        id: {
            type: Number,
            required: true,
        },
        month: {
            type: Number,
            required: true,
        },
        year: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            loadingPlusTimes: 0,
            loadingMinusTimes: 0,
            loadingPlusTimeSuggestions: 0,
            loadingMinusTimeSuggestions: 0,
            loadingProof: 0,
            plusTimeSuggestions: [],
            minusTimeSuggestions: [],
            plusTimes: [],
            minusTimes: [],
            proofOfTimes: [],
            selectedPlusTimes: [],
            selectedMinusTimes: [],
            selectedProofOfTimes: [],
            selected: {
                month: null,
                year: null,
            },
            showPlusTimeSuggestions: true,
            showMinusTimeSuggestions: true,
        };
    },
    computed: {
        linkBooking() {
            let year = this.selected.year;
            let month = this.selected.month + 1;
            if (month > 12) {
                month = 1;
                year++;
            }
            const queryString = `batch_processing_filter%5Bmonth%5D%5Bmonth%5D=${month}&batch_processing_filter%5Bmonth%5D%5Byear%5D=${year}`;

            return `/backend/child/${this.id}/booking?${queryString}`;
        },
    },
    created() {
        if (localStorage.getItem(this.getLocalStorageKeyPlusTimeSuggestions())) {
            this.showPlusTimeSuggestions = false;
        }
        if (localStorage.getItem(this.getLocalStorageKeyMinusTimeSuggestions())) {
            this.showMinusTimeSuggestions = false;
        }
    },
    methods: {
        duration(time) {
            return time.duration();
        },
        bulkSendPlusTimes() {
            this.loadingPlusTimes++;
            ChildTimeManagementRepository.createPlusTimes(this.id, this.selectedPlusTimes).then(() => {
                this.loadPlusTimes();
                this.loadingPlusTimes--;
            });

            this.selectedPlusTimes.slice(0).forEach((plusTime) => this.deleteFromList(this.plusTimeSuggestions, plusTime));
            this.selectedPlusTimes = [];
        },
        bulkSendMinusTimes() {
            this.loadingMinusTimes++;
            ChildTimeManagementRepository.createMinusTimes(this.id, this.selectedMinusTimes).then(() => {
                this.loadMinusTimes();
                this.loadingMinusTimes--;
            });

            this.selectedMinusTimes.slice(0).forEach((minusTime) => this.deleteFromList(this.minusTimeSuggestions, minusTime));
            this.selectedMinusTimes = [];
        },
        changeCareCost(plusTime, careCostHourly) {
            plusTime.careCostHourly = careCostHourly;
            ChildTimeManagementRepository.updatePlusTime(plusTime)
                .then(() => this.highlightRow(`#plusTime-${plusTime.id}`))
                .catch(() => this.loadPlusTimes());
        },
        deletePlusTime(plusTime) {
            this.deleteFromList(this.plusTimes, plusTime);
            this.loadingPlusTimeSuggestions++;
            ChildTimeManagementRepository.deletePlusTime(plusTime).then(() => {
                this.loadPlusTimeSuggestions();
                this.loadingPlusTimeSuggestions--;
            });
        },
        deleteMinusTime(minusTime) {
            this.deleteFromList(this.minusTimes, minusTime);
            this.loadingMinusTimeSuggestions++;
            ChildTimeManagementRepository.deleteMinusTime(minusTime).then(() => {
                this.loadMinusTimeSuggestions();
                this.loadingMinusTimeSuggestions--;
            });
        },
        applyPlusTime(plusTime) {
            this.deleteFromList(this.plusTimeSuggestions, plusTime);
            this.loadingPlusTimes++;
            ChildTimeManagementRepository.createPlusTime(this.id, plusTime).then(() => {
                this.loadPlusTimes();
                this.loadingPlusTimes--;
            });
        },
        applyMinusTime(minusTime) {
            this.deleteFromList(this.minusTimeSuggestions, minusTime);
            this.loadingMinusTimes++;
            ChildTimeManagementRepository.createMinusTime(this.id, minusTime).then(() => {
                this.loadMinusTimes();
                this.loadingMinusTimes--;
            });
        },
        updatePlusTime(plusTime, timeRange) {
            plusTime.timeRange.start = timeRange.start;
            plusTime.timeRange.end = timeRange.end;
            ChildTimeManagementRepository.updatePlusTime(plusTime).then(() => {
                this.highlightRow(`#plusTime-${plusTime.id}`);
                this.loadPlusTimeSuggestions();
                ChildTimeManagementRepository.findPlusTime(plusTime.id).then((newPlusTime) => plusTime.hint = newPlusTime.hint);
            });
        },
        updateMinusTime(minusTime, timeRange) {
            minusTime.timeRange.start = timeRange.start;
            minusTime.timeRange.end = timeRange.end;
            ChildTimeManagementRepository.updateMinusTime(minusTime).then(() => {
                this.highlightRow(`#minusTime-${minusTime.id}`);
                this.loadMinusTimeSuggestions();
                ChildTimeManagementRepository.findMinusTime(minusTime.id).then((newMinusTime) => minusTime.hint = newMinusTime.hint);
            });
        },
        loadPlusTimes() {
            this.loadingPlusTimes++;
            ChildTimeManagementRepository.findPlusTimes(this.id, this.selected.year, this.selected.month).then((plusTimes) => {
                this.plusTimes = plusTimes;
                this.loadingPlusTimes--;
            });
        },
        loadPlusTimeSuggestions() {
            this.loadingPlusTimeSuggestions++;
            ChildTimeManagementRepository.findPlusTimeSuggestions(this.id, this.selected.year, this.selected.month).then((plusTimes) => {
                this.plusTimeSuggestions = plusTimes;
                this.loadingPlusTimeSuggestions--;
            });
        },
        loadMinusTimes() {
            this.loadingMinusTimes++;
            ChildTimeManagementRepository.findMinusTimes(this.id, this.selected.year, this.selected.month).then((minusTimes) => {
                this.minusTimes = minusTimes;
                this.loadingMinusTimes--;
            });
        },
        loadMinusTimeSuggestions() {
            this.loadingMinusTimeSuggestions++;
            ChildTimeManagementRepository.findMinusTimeSuggestions(this.id, this.selected.year, this.selected.month).then((minusTimes) => {
                this.minusTimeSuggestions = minusTimes;
                this.loadingMinusTimeSuggestions--;
            });
        },
        loadProofOfTimes() {
            this.loadingProof++;
            ChildTimeManagementRepository.findProofOfTimes(this.id, this.selected.year, this.selected.month).then((proofOfTimes) => {
                this.proofOfTimes = proofOfTimes;
                this.loadingProof--;
            });
        },
        deleteProofOfTime(proofOfTime) {
            this.deleteFromList(this.proofOfTimes, proofOfTime);
            this.loadingProof++;
            ChildTimeManagementRepository.deleteProofOfTime(proofOfTime).then(() => {
                this.loadProofOfTimes();
                this.loadingProof--;
            });
        },

        deleteProofOfTimeBulk() {
            this.loadingProof++;
            ChildTimeManagementRepository.deleteProofOfTimeBulk(this.id, this.selectedProofOfTimes).then(() => {
                this.loadProofOfTimes();
                this.loadingProof--;
            });
            this.selectedProofOfTimes = [];
        },

        onSelectedMonthChanged(selection) {
            this.selected = selection;

            this.loadPlusTimes();
            this.loadPlusTimeSuggestions();
            this.loadMinusTimes();
            this.loadMinusTimeSuggestions();
            this.loadProofOfTimes();
        },
        highlightRow(id) {
            $(id).find('td').effect('highlight');
        },
        deleteFromList(list, element) {
            const index = list.indexOf(element);

            if (index > -1) {
                list.splice(index, 1);
            }
        },
        createProof() {
            this.loadingProof++;
            ChildTimeManagementRepository.createProof(this.id, this.selected.year, this.selected.month).then(() => {
                this.loadProofOfTimes();
                this.loadingProof--;
            });
        },
        toggleVisibilityPlusTimeSuggestions() {
            if (this.showPlusTimeSuggestions) {
                this.showPlusTimeSuggestions = false;
                localStorage.setItem(this.getLocalStorageKeyPlusTimeSuggestions(), true);
            } else {
                this.showPlusTimeSuggestions = true;
                localStorage.removeItem(this.getLocalStorageKeyPlusTimeSuggestions());
            }
        },
        toggleVisibilityMinusTimeSuggestions() {
            if (this.showMinusTimeSuggestions) {
                this.showMinusTimeSuggestions = false;
                localStorage.setItem(this.getLocalStorageKeyMinusTimeSuggestions(), true);
            } else {
                this.showMinusTimeSuggestions = true;
                localStorage.removeItem(this.getLocalStorageKeyMinusTimeSuggestions());
            }
        },
        getLocalStorageKeyPlusTimeSuggestions() {
            return 'showPlusTimeSuggestions';
        },
        getLocalStorageKeyMinusTimeSuggestions() {
            return 'showMinusTimeSuggestions';
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
table {
    th {
        width: 175px;
        &.dynamic {
            width: auto;
        }
        &.select {
            width: 15px;
        }
    }
    tfoot {
        td {
            text-align: right;
        }
    }
}
a {
    &.bulk_select {
        cursor: pointer;
    }
    &.textlinkDisabled {
        color: inherit;
        cursor: auto;
    }
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
.toogleListView {
    position: absolute;
    top: 30px;
    right: 5px;
}
.toogleListView a {
    cursor: pointer;
}
h3,
.status,
.toogleListView {
    display: inline-block;
}
.status {
    margin-left: 5px;
}
</style>
